export default "__VITE_ASSET__BZ7Top$2__"